import React from 'react';
import './ProfessionalExperience.css';
import { FaBriefcase, FaCalendarAlt, FaExternalLinkAlt } from 'react-icons/fa';
import { experienceData } from '../data/experienceData';

const ProfessionalExperience = () => {
    return (
        <section className="experience-section" id="experience">
            <div className="cyber-grid"></div>
            <div className="section-container">
                <div className="section-header">
                    <span className="section-badge">CAREER &amp; TRACK RECORD</span>
                    <h2 className="section-title">Professional Experience</h2>
                    <p className="section-subtitle">
                        Demonstrated engineering leadership delivering resilient backend architectures, high-concurrency distributed systems, and scalable full-stack platforms.
                    </p>
                </div>

                <div className="exp-timeline">
                    {experienceData.map((item, index) => (
                        <div className="exp-node-container" key={item.id || index}>
                            <div className="exp-node-marker">
                                <div className={`exp-node-dot ${index === 0 ? 'active' : ''}`}></div>
                            </div>

                            <article className={`exp-card ${index === 0 ? 'current-engagement' : ''}`}>
                                <header className="exp-card-header">
                                    <div className="exp-header-info">
                                        <div className="exp-role-title-row">
                                            <h3 className="exp-role-title">{item.role}</h3>
                                            <span className={`exp-role-badge ${item.tag.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`}>
                                                {item.tag}
                                            </span>
                                        </div>
                                        <div className="exp-company-wrap">
                                            <FaBriefcase className="exp-header-icon" />
                                            {item.url ? (
                                                <a
                                                    href={item.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="exp-company-link"
                                                    title={`Visit ${item.company} (${item.url})`}
                                                >
                                                    <span>{item.company}</span>
                                                    <FaExternalLinkAlt className="exp-link-icon" />
                                                </a>
                                            ) : (
                                                <span className="exp-company-name">{item.company}</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="exp-duration-chip">
                                        <FaCalendarAlt className="exp-cal-icon" />
                                        <span>{item.duration}</span>
                                    </div>
                                </header>

                                <p className="exp-summary">{item.summary}</p>

                                <div className="exp-achievements">
                                    {item.achievements.map((ach, idx) => (
                                        <div className="exp-ach-item" key={idx}>
                                            <span className="exp-ach-metric">{ach.metric}</span>
                                            <span className="exp-ach-label">{ach.label}</span>
                                        </div>
                                    ))}
                                </div>

                                <div className="exp-tech-tags">
                                    {item.techStack.map((tech, idx) => (
                                        <span className="exp-tag" key={idx}>
                                            <span className="exp-tag-hash">#</span>
                                            <span>{tech}</span>
                                        </span>
                                    ))}
                                </div>
                            </article>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProfessionalExperience;